<table [dataSource]="items" mat-table class="condensed">
  <ng-container matColumnDef="name">
    <th *matHeaderCellDef mat-header-cell>Bindingstid</th>
    <td *matCellDef="let interest;" mat-cell>
      {{ interest.product | binding }}
    </td>
  </ng-container>

  @for (ltv of ltvs; track $index) {
    <ng-container [matColumnDef]="ltv">
      <th *matHeaderCellDef mat-header-cell
          style="padding: 0 12px 0 0;white-space: nowrap; text-align: center">
        <!-- First and last columns are special -->
        <div style="font-weight: normal">{{ ltv }}</div>
      </th>
      <td *matCellDef="let row;index as binding" mat-cell
          [class.item]="diff('l753', binding, +ltv) < 0"
          [style.background-color]="color(diff('l753', binding, +ltv))"
      >
        <div style="white-space: nowrap">
          {{ diff('l753', binding, +ltv) | number: '1.2-2' }}
        </div>
      </td>
    </ng-container>
  }

  <tr *matHeaderRowDef="columns()" mat-header-row style="font-weight: bold"></tr>
  <tr *matRowDef="let row; columns: columns()" mat-row></tr>
</table>